import { html } from "lit";

export const Template = () => html`
    <div class="ux-row">
        <div class="ux-col ux-u-my-m">
            <h2
                class="ux-text-headline ux-text-headline--big ux-u-text-align--center"
            >
                Power by the Hour in Zahlen
            </h2>
        </div>
    </div>
`;
